export const getMeasurementValue = (measurement) => {
  if (measurement.type === "glucose") {
    return measurement.measurement.glucose;
  } else if (measurement.type === "pulse") {
    return measurement.measurement.pulse;
  } else if (measurement.type === "oxygen") {
    return measurement.measurement.bloodOxygen;
  } else if (measurement.type === "temp") {
    return measurement.measurement.bodyTemperature;
  }
};
